import React, { ReactNode, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { KivuI18nContext, localizedPath } from "@kivunova/kivufrontendcommon";
import ForgotOtpForm from "./ForgotPassword";
import ResetPasswordForm from "./ResetPassword"; // Component A
import { FORGOT_PWD_STEP } from "./Enums/forgotPasswordSteps";
import { PAGE_ROUTE_LOGIN } from "@kivunova/kivufrontendcommon";
import { Box } from "@mui/material";
import AuthSidePanel from "../common/AuthSidePanel/AuthSidePanel";
import AuthRightSidePanel from "../common/AuthSidePanel/AuthRightSidePanel";
import SmallScreenFooter from "../common/SmallScreenFooter";

const ForgotPasswordWrapper = () => {
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext);

  const [currentStep, setCurrentStep] = useState<FORGOT_PWD_STEP>(
    FORGOT_PWD_STEP.INITIAL
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_loginInfo, setLoginInfo] = useState<string | undefined>();

  const handleSuccess = () => {
    navigate(localizedPath(PAGE_ROUTE_LOGIN, language, defaultLang));
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const backToLogin = () => {
    navigate(localizedPath(PAGE_ROUTE_LOGIN, language, defaultLang));
  };

  // When OTP is requested successfully, go to reset directly
  const handleOtpRequested = () => {
    setCurrentStep(FORGOT_PWD_STEP.RESET);
  };

  let content: ReactNode;

  // STEP 2: Reset password form (only step needed after OTP)
  if (currentStep === FORGOT_PWD_STEP.RESET) {
    content = <ResetPasswordForm handleSuccess={handleSuccess} />;
  }

  // STEP 1: Request OTP form (initial screen)
  else {
    content = (
      <ForgotOtpForm setNextStep={handleOtpRequested} setEmail={setLoginInfo} />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100%",
        background: "white",
        position: "relative"
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "none", lg: "flex", xl: "flex" },
          flex: 1
        }}
      >
        <AuthSidePanel />
      </Box>

      <AuthRightSidePanel>{content}</AuthRightSidePanel>
      <SmallScreenFooter />
    </Box>
  );
};

export default ForgotPasswordWrapper;
